import { render, staticRenderFns } from "./ClientsNew.vue?vue&type=template&id=4fc8e568&"
import script from "./ClientsNew.vue?vue&type=script&lang=js&"
export * from "./ClientsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports